import { Center } from "@/components/Center";
import { Text } from "@/components/Text";

import { DashboardJob, JobDifficulty } from "@/types";

import { LevelBarIndicator } from "./LevelBarIndicator";

const DIFFICULTY_CONFIG: Record<
  JobDifficulty,
  { barCount: number; barActiveClassName: string }
> = {
  [JobDifficulty.EASY]: {
    barCount: 1,
    barActiveClassName: "bg-lever-icon-success",
  },
  [JobDifficulty.MODERATE]: {
    barCount: 2,
    barActiveClassName: "bg-lever-icon-warning",
  },
  [JobDifficulty.DIFFICULT]: {
    barCount: 3,
    barActiveClassName: "bg-lever-icon-warning",
  },
  [JobDifficulty.VERY_DIFFICULT]: {
    barCount: 4,
    barActiveClassName: "bg-lever-icon-error",
  },
};

export const DashboardDifficultyCell = ({
  difficulty,
}: {
  difficulty: DashboardJob["difficulty"];
}) => {
  const render = () => {
    if (difficulty === null) {
      return (
        <Center className="h-6 w-8 px-1">
          <Text className="text-sm font-normal text-lever-text-disabled">
            —
          </Text>
        </Center>
      );
    }

    const config = DIFFICULTY_CONFIG[difficulty];
    return (
      <Center className="h-6 w-8 px-1">
        <LevelBarIndicator
          activeClassName={config.barActiveClassName}
          filledCount={config.barCount}
          maxBars={4}
        />
      </Center>
    );
  };

  return render();
};
